"use strict";
var Observable_1 = require('../../Observable');
var bufferWhen_1 = require('../../operator/bufferWhen');
Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
//# sourceMappingURL=bufferWhen.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/rxjs/add/operator/bufferWhen.js
// module id = ../../../../rxjs/add/operator/bufferWhen.js
// module chunks = 4